import { GridColumnHeaderParams } from "@mui/x-data-grid-pro";
import { useDataGridSettings } from "@/components/DataGridSettingsProvider";

export const RenderHeader = (params: GridColumnHeaderParams) => {
  const { field, colDef } = params;
  const { columnNames } = useDataGridSettings();

  return <strong>{field in columnNames ? columnNames[field] : colDef.headerName}</strong>;
};
